export const PriorityTypes = {
  CHANGE_PRIORITY: "CHANGE_PRIORITY",
};

export const NavTypes = {
  CHANGE_NAV: "CHANGE_NAV",
};
